export default __webpack_public_path__ + "static/media/300-600.31e33997.png";